import { useEffect } from 'react'

import lottie from 'lottie-web'
import { useTranslation } from 'react-i18next'
import Image from 'next/image'

import { PREFIX_URL } from '@/config/constants'

import ComponentStyled from './styled'

type Props = {
  showSemiCircle?: boolean
  startAnimation?: boolean
  animationUrl?: string
  onPlayAnimation?: () => void
}

const ANIMATION_DELAY = 4000

const PlantsAnimation = ({
  showSemiCircle = false,
  startAnimation = false,
  animationUrl,
  onPlayAnimation,
}: Props): JSX.Element => {
  const { t } = useTranslation()

  useEffect(() => {
    async function initAnimation() {
      const container = document.querySelector('#seed-animation')

      if (startAnimation && container) {
        try {
          const response = await fetch(`${PREFIX_URL}${animationUrl}`)
          const animationData = await response.json()

          lottie.loadAnimation({
            container,
            animationData,
            renderer: 'svg',
            loop: false,
            autoplay: false,
          })

          lottie.setSpeed(1.5)

          setTimeout(() => {
            onPlayAnimation?.()
            lottie.play()
          }, ANIMATION_DELAY)
        } catch {}
      }
    }

    initAnimation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startAnimation])

  return (
    <ComponentStyled showSemiCircle={showSemiCircle}>
      <Image src='/images/land.png' priority alt={t('land')} layout='fill' objectFit='cover' objectPosition='top' />

      <div className='plant pear-millet'>
        <div className='plant-img'>
          <Image src='/images/pear.png' alt={t('pear millet')} layout='fill' objectFit='contain' />
        </div>
      </div>
      <div className='plant beans'>
        <div className='plant-img'>
          <Image src='/images/beans.png' alt={t('beans')} layout='fill' objectFit='contain' />
        </div>
      </div>
      <div className='plant lentils'>
        <div className='plant-img'>
          <Image src='/images/lentils.png' alt={t('lentils')} layout='fill' objectFit='contain' />
        </div>
      </div>
      <div className='semicircle'>
        <div className='semicircle-img'>
          <Image src='/images/semicircle.png' alt={t('Semi Circle')} layout='fill' objectFit='contain' />
        </div>
      </div>
      <div className='plant sorghum'>
        <div className='plant-img'>
          <Image src='/images/sorghum.png' alt={t('sorghum')} layout='fill' objectFit='contain' />
        </div>
      </div>
      <div className='plant pea'>
        <div className='plant-img'>
          <Image src='/images/pea.png' alt={t('pea')} layout='fill' objectFit='contain' />
        </div>
      </div>
      <div id='seed-animation' />
    </ComponentStyled>
  )
}

export default PlantsAnimation
